import { createSvgIcon } from '@mui/material';

export const LocationTimeWindow = createSvgIcon(
  <g transform="translate(2, 5)">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3.40909L6.66667 0L13.3333 3.40909V4.9706C12.3106 5.28216 11.434 5.94289 10.8367 6.81818H1.33333V12.2727H0V3.40909ZM1.33333 5.45455H4V4.09091H1.33333V5.45455ZM5.33333 4.09091V5.45455H8V4.09091H5.33333ZM9.33333 5.45455H12V4.09091H9.33333V5.45455Z"
    />
    <path d="M2.66667 8.18182H4V9.54545H2.66667V8.18182Z" />
    <path d="M2.66667 10.9091H4V12.2727H2.66667V10.9091Z" />
    <path d="M6.66667 8.18182H5.33333V9.54545H6.66667V8.18182Z" />
    <path d="M5.33333 10.9091H6.66667V12.2727H5.33333V10.9091Z" />
    <path d="M9.33333 10.9091H8V12.2727H9.33333V10.9091Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6667 10.2273C10.6667 7.58864 12.76 5.45455 15.3333 5.45455C17.9133 5.45455 20 7.58864 20 10.2273C20 12.8659 17.9067 15 15.3333 15C12.7533 15 10.6667 12.8659 10.6667 10.2273ZM18.5667 10.2273C18.5667 8.4 17.1133 6.92045 15.3333 6.92045C13.5467 6.92045 12.1 8.4 12.1 10.2273C12.1 12.0545 13.5467 13.5341 15.3333 13.5341C17.12 13.5341 18.5667 12.0545 18.5667 10.2273ZM14.6667 10.6977V8.18182H15.6667V10.1045L17.2933 11.0659L16.7933 11.9523L14.6667 10.6977Z"
    />
  </g>,
  'LocationTimeWindow',
);
